import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { AuthService } from './auth.service';
import { ToastService } from '../toast/toast.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private toastService: ToastService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let isauthenticated = this.authService.isAuthenticated();

    if (isauthenticated()) {
      return true;
    } else {
      this.router.navigate(['/login']);
      this.toastService.add(
        `O período de permanência expirou. Por favor, faça login novamente!`,
        30000,
        'warning'
      );
      return false;
    }
  }
}
